export const PLACEHOLDERS_OBRIGATORIOS = ['{dia_atual}', '{nome_lead}', '{telefone_lead}']

/** Calculado no cliente a cada tecla — o servidor confere de novo ao publicar. */
export function placeholdersAusentes(conteudo) {
  const texto = String(conteudo ?? '')
  return PLACEHOLDERS_OBRIGATORIOS.filter((p) => !texto.includes(p))
}

export function AvisoPlaceholders({ conteudo }) {
  const ausentes = placeholdersAusentes(conteudo)

  if (ausentes.length === 0) {
    return (
      <div className="placeholders placeholders--ok">
        <span className="ponto ok" /> Placeholders obrigatórios presentes
      </div>
    )
  }

  return (
    <div className="placeholders placeholders--aviso">
      <span className="ponto aviso" />
      <span>
        Faltando:{' '}
        {ausentes.map((p) => (
          <code key={p}>{p}</code>
        ))}
        <span className="placeholders__nota"> — avisa, não bloqueia a publicação.</span>
      </span>
    </div>
  )
}
